import { useMemo, useState } from "react";

const CATEGORIES = [
  { key: "all", label: "Tümü" },
  { key: "power", label: "Elektrikli Aletler" },
  { key: "adhesive", label: "Yapıştırıcı & Mastik" },
  { key: "foam", label: "Poliüretan Köpük" },
  { key: "spray", label: "Sprey & Bakım" },
  { key: "electric", label: "Elektrik & Aksesuar" },
];

const PRODUCTS = [
  {
    key: "kimmeer-mavi",
    category: "power",
    name: "Kimmeer Plus Mavi Matkap",
    desc:
      "Çelik mandrelli şarjlı matkap seti. Komple aksesuar, şarj cihazı ve taşıma çantasıyla birlikte.",
    price: "2.000 ₺",
    img: "/assets/product-kimmeer-mavi.jpg",
  },
  {
    key: "kimmeer-kirmizi",
    category: "power",
    name: "Kimmeer Plus Kırmızı Matkap",
    desc:
      "Çelik mandrelli şarjlı matkap seti. Güçlü tork, geniş uç yelpazesi ve garanti belgeli.",
    price: "1.750 ₺",
    img: "/assets/product-kimmeer-kirmizi.jpg",
  },
  {
    key: "ryandor",
    category: "power",
    name: "Ryandor Zincirli Testere",
    desc:
      "Şarjlı zincirli testere RYN-ZT1010. Bahçe ve hafif kesim işleri için brushless motorlu, taşıma çantalı.",
    price: "4.600 ₺",
    img: "/assets/product-ryandor.jpg",
  },
  {
    key: "akfix",
    category: "adhesive",
    name: "Akfix Hızlı Yapıştırıcı",
    desc:
      "Profesyonel kullanım için hızlı kürlenen yapıştırıcı. Plastik, metal, ahşap ve çoğu yüzeyde güçlü tutuş.",
    price: "100 – 130 ₺",
    img: "/assets/product-akfix.jpg",
  },
  {
    key: "dayson",
    category: "adhesive",
    name: "Dayson Extra PU Sealant",
    desc:
      "Profesyonel poliüretan mastik. Yapı, otomotiv ve genel sızdırmazlık işlerinde yüksek dayanım.",
    price: "200 ₺",
    img: "/assets/product-dayson.jpg",
  },
  {
    key: "sibax-kopuk",
    category: "foam",
    name: "Sibax Poliüretan Köpük",
    desc:
      "Yüksek genleşmeli profesyonel poliüretan köpük. Yalıtım, boşluk doldurma ve montaj işlerinde ideal.",
    price: "90 ₺",
    img: "/assets/product-sibax-kopuk.jpg",
  },
  {
    key: "akfix-kopuk",
    category: "foam",
    name: "Akfix Poliüretan Köpük",
    desc:
      "Profesyonel poliüretan montaj köpüğü. Hızlı kürlenme, yüksek verim ve güçlü yapışma.",
    price: "100 ₺",
    img: "/assets/product-akfix.jpg",
  },
  {
    key: "akcali",
    category: "spray",
    name: "Akçalı Sprey Boyalar",
    desc:
      "Düz ve metalik renk seçenekleriyle çabuk kuruyan sprey boya. Pürüzsüz ve eşit kapama.",
    price: "150 – 200 ₺",
    img: "/assets/product-akcali.jpg",
  },
  {
    key: "selsil",
    category: "spray",
    name: "Selsil Yağlayıcı",
    desc:
      "Pas sökücü ve yağlayıcı sprey. Sıkışmış parçaları gevşetir, mekanik aksamı temizler ve korur.",
    price: "75 ₺",
    img: "/assets/product-selsil.jpg",
  },
  {
    key: "sibax-balata",
    category: "spray",
    name: "Sibax Fren Balatası Temizleyici",
    desc:
      "SB1000 Brake & Parts Cleaner. Fren balatası ve genel temizleyici; yağ ve lekeleri etkili biçimde çıkarır.",
    price: "80 ₺",
    img: "/assets/product-sibax-balata.jpg",
  },
  {
    key: "makara",
    category: "electric",
    name: "Seyyar Kablolu Makara",
    desc:
      "3000W maksimum güç, 4 entegre prizli, darbeye dayanıklı gövde. Atölye ve şantiye için pratik enerji.",
    price: "1.000 ₺",
    note: "Farklı boyutları mevcuttur.",
    img: "/assets/product-makara.jpg",
  },
];

export default function Products() {
  const [active, setActive] = useState("all");

  const filtered = useMemo(
    () => (active === "all" ? PRODUCTS : PRODUCTS.filter((p) => p.category === active)),
    [active]
  );

  const counts = useMemo(() => {
    const c = { all: PRODUCTS.length };
    CATEGORIES.forEach((cat) => {
      if (cat.key !== "all") c[cat.key] = PRODUCTS.filter((p) => p.category === cat.key).length;
    });
    return c;
  }, []);

  return (
    <section
      id="products"
      data-testid="products-section"
      className="py-24 lg:py-32 bg-[var(--tt-cream)]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-10">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.22em] text-[var(--tt-orange)]">
              Ürünlerimiz
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--tt-green-900)] mt-4 leading-[1.02] max-w-2xl">
              Öne çıkan ürünler ve fiyatlar.
            </h2>
          </div>
          <p className="text-sm text-[var(--tt-charcoal)]/70 max-w-sm">
            Stoklarımızdan seçili ürünler. Güncel fiyat ve stok için WhatsApp&apos;tan
            ulaşabilirsiniz.
          </p>
        </div>

        {/* Category filters */}
        <div
          data-testid="product-category-tabs"
          className="flex flex-wrap gap-2 sm:gap-3 mb-10"
        >
          {CATEGORIES.map((cat) => {
            const isActive = active === cat.key;
            return (
              <button
                key={cat.key}
                data-testid={`category-tab-${cat.key}`}
                onClick={() => setActive(cat.key)}
                className={`inline-flex items-center gap-2 rounded-full px-4 sm:px-5 py-2.5 text-sm font-bold transition-all border ${
                  isActive
                    ? "bg-[var(--tt-green-800)] text-white border-[var(--tt-green-800)] shadow-md"
                    : "bg-white text-[var(--tt-charcoal)]/80 border-black/10 hover:border-[var(--tt-green-800)]/30 hover:text-[var(--tt-green-800)]"
                }`}
              >
                {cat.label}
                <span
                  className={`text-[10px] font-bold rounded-full px-2 py-0.5 ${
                    isActive
                      ? "bg-white/15 text-white"
                      : "bg-[var(--tt-cream-dark)] text-[var(--tt-charcoal)]/70"
                  }`}
                >
                  {counts[cat.key]}
                </span>
              </button>
            );
          })}
        </div>

        <div
          data-testid="products-grid"
          className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
        >
          {filtered.map((p) => (
            <article
              key={p.key}
              data-testid={`product-card-${p.key}`}
              className="svc-card group rounded-3xl bg-white border border-black/5 overflow-hidden shadow-sm flex flex-col rise"
            >
              <div className="relative aspect-square overflow-hidden bg-[var(--tt-cream-dark)]">
                <img
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 px-3 py-1 rounded-full bg-black/55 text-white text-[10px] font-bold uppercase tracking-widest backdrop-blur">
                  {CATEGORIES.find((c) => c.key === p.category)?.label}
                </div>
                <div className="absolute top-3 right-3 px-3 py-1.5 rounded-full bg-[var(--tt-orange)] text-white text-xs font-bold shadow-md">
                  {p.price}
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-display text-lg text-[var(--tt-green-900)] leading-tight">
                  {p.name}
                </h3>
                <p className="text-sm text-[var(--tt-charcoal)]/75 mt-2 leading-relaxed flex-1">
                  {p.desc}
                </p>
                {p.note && (
                  <div
                    data-testid={`product-note-${p.key}`}
                    className="mt-4 flex items-start gap-2 text-xs font-semibold text-[var(--tt-green-800)] bg-[var(--tt-green-800)]/8 border border-[var(--tt-green-800)]/15 rounded-lg px-3 py-2"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      className="w-4 h-4 mt-0.5 shrink-0"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="16" x2="12" y2="12" />
                      <line x1="12" y1="8" x2="12.01" y2="8" />
                    </svg>
                    <span>{p.note}</span>
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
